/**
 * Reducers specify how the application's state changes in response to actions sent to the store.
 *
 * @see https://redux.js.org/basics/reducers
 */

import { createReducer } from 'reduxsauce';
import { SlsOrdExcel01Types } from './Actions';
import INITIAL_STATE from './InitialState';

export const slsOrdExcel01SetStrProcType = (state, { strProcType }) => ({
  ...state,
  strProcType
});

export const slsOrdExcel01ShowBatchJobStatusSuccess = (state, { batchJobStatus }) => ({
  ...state,
  batchJobStatus
});

export const slsOrdExcel01UploadLoading = (state, { boolean }) => ({
  ...state,
  uploadIsLoading: boolean
});

/**
 * @see https://github.com/infinitered/reduxsauce#createreducer
 */
export const reducer = createReducer(INITIAL_STATE, {
  [SlsOrdExcel01Types.SLS_ORD_EXCEL01_SET_STR_PROC_TYPE]: slsOrdExcel01SetStrProcType,
  [SlsOrdExcel01Types.SLS_ORD_EXCEL01_SHOW_BATCH_JOB_STATUS_SUCCESS]: slsOrdExcel01ShowBatchJobStatusSuccess,
  [SlsOrdExcel01Types.SLS_ORD_EXCEL01_UPLOAD_LOADING]: slsOrdExcel01UploadLoading
});
